import { RefObject, useEffect, useRef, useState } from 'react'
import { Size } from '@st/geom'

export function useResizeObserver<T extends Element>(
  ref: RefObject<T | null>,
  delay = 250
): Size | undefined {
  const [size, setSize] = useState<{ width: number; height: number }>()
  const latestSize = useRef(size)
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (!ref.current) return

    const ro = new ResizeObserver(([entry]) => {
      if (timer.current) clearTimeout(timer.current)
      timer.current = setTimeout(() => {
        const next = {
          width: entry.contentRect.width,
          height: entry.contentRect.height
        }
        if (
          !latestSize.current ||
          next.width !== latestSize.current.width ||
          next.height !== latestSize.current.height
        ) {
          latestSize.current = next
          setSize(next)
        }
      }, delay)
    })

    ro.observe(ref.current)
    return () => {
      if (timer.current) clearTimeout(timer.current)
      ro.disconnect()
    }
  }, [ref, delay])

  return size
}
